import {
  Box,
  Button,
  Card,
  DialogActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Log, getPendingMerchantPayoutInfo, getPendingMerchantPayoutInfoDetails, MerchantPayoutApprover, sendDataWithGet } from "../../services/services";
import ListHead from "../../components/table/ListHead";
import Scrollbar from "../../components/table/Scrollbar";
import { StyledTableRow } from "../../components/TableRow";
import { useLoadingSpinnerContext } from "../../context/loadingSpinnerContext";
import { CustomTableCell } from "../../components/TableCell";
import CommonDialog from "../../components/CustomDialog";
import CircularLoader from "../../components/circularLoader";
import { styles } from "../../utils/styles";
import RejectDialog from "./Dialogs/RejectDialog";
import MerchantPayoutInfoDetails from "./Dialogs/PendingDetail";
import Pagination from "../../components/Pagination";
import FormSearch from "../../components/FormSearch";
import { isEmpty } from "lodash";

const TABLE_HEAD = [
  { id: "merchant_name", label: "Merchant" },
  { id: "terminal_id", label: "Terminal ID" },
  { id: "payment_brand_name", label: "Payment Brand" },
  { id: "payment_host_name", label: "Payment Host" },
  { id: "payment_cycle", label: "Payment Cycle" },
  { id: "action", label: "Action" },
  { id: "details" },
];

const PendingMerchantPayoutInfo = ({ userRole }) => {
  const { setGlobalLoading } = useLoadingSpinnerContext();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [merchantPayoutList, setMerchantPayoutList] = useState({ results: [], count: 0 });
  const [loaded, setLoaded] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, page_size: 50 });

  // filters
  const [filter, setFilter] = useState({});
  const [filterCondition, setFilterCondition] = useState({});
  const [fLoaded, setFLoaded] = useState(false);

  // dialogs
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [pendingDetails, setPendingDetails] = useState(null);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredList = merchantPayoutList?.results || []

  const isItemNotFound = filteredList.length === 0;

  const queryPage = (params, payload = filter) => {
    loaded && setLoaded(false);
    getPendingMerchantPayoutInfo(setMerchantPayoutList, setLoaded, {
      queryParams: params || pagination,
      payload,
    });
    params && setPagination(params);
  };

  const handleChangePage = (event, newPage) => {
    queryPage({
      page: newPage + 1,
      page_size: pagination.page_size,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    queryPage({
      page: 1,
      page_size: event.target.value,
    });
  };

  const getFilterCondition = () => {
    const url = `/bank_account/merchant_payout_info_pending/filter_conditions/`;
    sendDataWithGet(url, setFilterCondition, setFLoaded);
  };

  const onFilterSubmit = (fParams) => {
    const newParams = {
      merchant_id: fParams?.merchant?.id,
      terminal_id: fParams?.terminal?.id,
      payment_host_id: fParams?.payment_host?.id,
      payment_cycle: fParams?.payment_cycle?.id,
    };

    const newPagination = {
      ...pagination,
      page: 1,
    };

    Log.info("Search Pending Merchant Payout Info list", newParams);
    setFilter(newParams);
    queryPage(newPagination, newParams);
  };

  const schema = [
    {
      type: "search-select",
      label: "Merchant",
      param: "merchant",
      options: filterCondition?.merchant?.map((item) => ({
        label: item.merchant__name,
        id: item.merchant__id,
      })),
    },
    {
      type: "search-select",
      label: "Terminal",
      param: "terminal",
      options: filterCondition?.terminal?.map((item) => ({
        label: item.terminal__terminal_id,
        id: item.terminal__id,
      })),
    },
    {
      type: "search-select",
      label: "Payment Host",
      param: "payment_host",
      options: filterCondition?.payment_host?.map((item) => ({
        label: item.payment_host__name,
        id: item.payment_host__id,
      })),
    },
    {
      type: "search-select",
      label: "Payment Cycle",
      param: "payment_cycle",
      options: filterCondition?.payment_cycle?.map((item) => ({
        label: item.name,
        id: item.id,
      })),
    },
  ];

  useEffect(() => {
    getFilterCondition();
    queryPage();
  }, []);

  const handleCloseDialog = (shouldResetDetails) => {
    setOpenRejectDialog(false);
    if (shouldResetDetails === true) setPendingDetails(null);
  };

  return (
    <Box>
      <FormSearch
        schema={schema}
        loading={fLoaded}
        onSearch={onFilterSubmit}
      />
      {loaded ?
        <Card>
          <Scrollbar>
            <TableContainer>
              <Table>
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                  checkbox={false}
                />

                <TableBody>
                  {filteredList && filteredList.length > 0 && filteredList.map((row) => {
                    const { id, merchant, terminal, payment_brand, payment_host, payment_cycle, action } = row;

                    return (
                      <StyledTableRow
                        hover
                        key={id}
                      >
                        <CustomTableCell field={merchant.name} />
                        <CustomTableCell field={terminal.terminal_id} />
                        <CustomTableCell field={payment_brand?.name} />
                        <CustomTableCell field={payment_host?.name} />
                        <CustomTableCell field={payment_cycle} />
                        <CustomTableCell field={action} />
                        <TableCell>
                          <Button
                            variant="text"
                            color="secondary"
                            onClick={() => {
                              setGlobalLoading(true);
                              getPendingMerchantPayoutInfoDetails(id, setPendingDetails, () => setGlobalLoading(false)
                              );
                            }}
                          >
                            View Detail
                          </Button>
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
                {isItemNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            There are no pending merchant payout info at the moment.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {!isEmpty(merchantPayoutList?.results) && (
            <Pagination
              count={merchantPayoutList.count}
              pagination={pagination}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Card>
        :
        <CircularLoader />
      }
      {selectedId && (
        <RejectDialog
          open={openRejectDialog}
          onClose={handleCloseDialog}
          id={selectedId}
          cb={queryPage}
        />
      )}

      {pendingDetails && (
        <CommonDialog
          title="Merchant Payout Info Details"
          onClose={() => setPendingDetails(null)}
          renderActions={() =>
            userRole.includes("Approve/Reject") && (
              <DialogActions>
                <Button
                  variant="outlined"
                  // color="inherit"
                  onClick={() => {
                    setOpenRejectDialog(true);
                    setSelectedId(pendingDetails.id);
                  }}
                >
                  Reject
                </Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setGlobalLoading(true);
                    Log.info(
                      `Click button [Approve] - Approve Merchant Payout Info by Id: ${pendingDetails.id}`
                    );
                    await MerchantPayoutApprover(
                      pendingDetails.id,
                      "approve",
                      { cb: queryPage }
                    );
                    setPendingDetails(null);
                    setGlobalLoading(false);
                  }}
                  sx={{ ...styles.customButton }}
                >
                  Approve
                </Button>
              </DialogActions>
            )
          }
        >
          <MerchantPayoutInfoDetails detailsData={pendingDetails} />
        </CommonDialog>
      )}
    </Box>
  );
};

export default PendingMerchantPayoutInfo;
